import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ControlType } from './filter-enum';
import { FilterOption } from './filter-model';
import { MasterConstants } from '../../../common/constants/master-constants';

import * as _moment from 'moment';
import { ReportType } from '../../../models/report-type.model';
import { UserReportFilter } from '../../../models/user-report-filter.model';
import { UserFilterColumnDisplayed } from '../../../models/user-filter-columndisplayed.model';
import { BranchPlantVM } from '../../../models/ShippingAvailability/BranchPlantVM';
import { ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnChanges {
  @ViewChild('maturityToSearch') maturityToSelect: NgSelectComponent;
  @ViewChild('maturityFromSearch') maturityFromSelect: NgSelectComponent;

  @Input() optionsData: Array<FilterOption> = [];
  @Input() filterData = new Object();
  @Input() showSearchButton = true;
  @Input() isSearchButtonOutside = false;
  @Input() reportType: ReportType = null;
  @Input() isDisableSearchButton = false;
  @Input() isShowFilterButton = false;
  @Input() currentFilter = new UserReportFilter();
  @Input() shippingAvailabilityList: any = [];
  @Input() isReleaseOrderEnable: boolean = false;
  @Input() hasReleaseOrderAccess: boolean = false;
  @Input() isDisableWholeFilter: boolean = false;
  @Output() searchClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearAllClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectFilterClick: EventEmitter<UserFilterColumnDisplayed> = new EventEmitter<UserFilterColumnDisplayed>();
  @Output() addFilterClick: EventEmitter<UserFilterColumnDisplayed> = new EventEmitter<UserFilterColumnDisplayed>();
  @Output() editFilterClick: EventEmitter<UserFilterColumnDisplayed> = new EventEmitter<UserFilterColumnDisplayed>();
  @Output() saveFilterClick: EventEmitter<UserFilterColumnDisplayed> = new EventEmitter<UserFilterColumnDisplayed>();
  @Output() exportClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() emailDataClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() releaseOrderClick: EventEmitter<any> = new EventEmitter<any>();

  controlType = ControlType;
  selectedValue: string;
  selectedOption: FilterOption = new FilterOption();
  filter: any = new Object();
  userNameFilter: any = new Object();
  filterValueList = new Array();
  compomentWidth: number = 12;

  constructor(
    private toastrService: ToastrService,
    private datePipe: DatePipe,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['optionsData'] && !changes['optionsData'].firstChange) {
      // This block is triggered when `optionsData` changes after ngOnInit
      this.ngOnInit();
    }
    const option = changes["optionsData"];
    const filter = changes["filterData"];
    const curFilter = changes["currentFilter"]?.currentValue;

    if (curFilter)
      this.currentFilter = curFilter;

    if (option && filter) {
      this.resetPageFilter();
      this.filter = this.filterData;

      this.searchEmit();
    }
  }

  ngOnInit() {
    if (this.optionsData && this.optionsData.length) {
      let selectedFilters = this.optionsData.filter(x => x.filterValue);
      if (selectedFilters && selectedFilters.length) {
        selectedFilters.forEach(opt => {
          let filterValueData = this.optionsData.find(x => x.key == opt.key);
          this.selectedValue = filterValueData.key;
          this.selectedOption = filterValueData;
          if (this.selectedOption.controlType === ControlType.DropDown) {
            const filterValuesSet = new Set(
              (Array.isArray(this.selectedOption.filterValue)
                ? this.selectedOption.filterValue
                : (this.selectedOption.filterValue ?? '').toString().split(',')
              ).map(x => x.trim())
            );

            let selectedObj = {
              selectedValues: this.selectedOption.controlData.filter(item =>
                filterValuesSet.has(item[this.selectedOption.controlDataBindValue]))
            };
            this.retainFilter(selectedObj, true);
          } else {
            this.retainFilter(null, true);
          }
        });
        this.searchEmit();
      } else {
        this.selectedValue = this.optionsData[0].key;
        this.selectedOption = this.optionsData[0];
      }
    } else {
      this.selectedValue = null;
      this.selectedOption = null;
    }

    this.checkAndSetDefaultOptionValues();

    if (this.reportType === 8) {
      this.compomentWidth = (this.isSearchButtonOutside ? 9 : 11);
    }
    else {
      this.compomentWidth = (this.isSearchButtonOutside ? 10 : 12);
    }
  }

  // Set value while change filter option
  filterOptionChange() {
    this.selectedOption = this.optionsData.find(x => x.key === this.selectedValue);
    this.checkAndSetDefaultOptionValues();
  }

  checkAndSetDefaultOptionValues() {
    if (this.selectedOption && this.selectedOption.isMultiSelect !== false) {
      this.selectedOption.isMultiSelect = true;
    }
  }

  // Emit while search button click
  searchEmit() {
    this.retainFilter(null, true);
    this.searchClick.emit(this.filter);
  }

  // Emit while search button click
  exportEmit() {
    this.retainFilter(null, true);
    this.exportClick.emit(this.filter);
  }

  // Emit while search button click
  emailDataEmit() {
    this.retainFilter(null, true);
    this.emailDataClick.emit(this.filter);
  }

  // Retain filter while change value
  retainFilter(selectedObj: any = null, isSearchClick: boolean = false) {
    if (this.selectedOption.controlType == ControlType.Integer) {
      this.selectedOption.filterValue = this.validateNumText(this.selectedOption.filterValue);
    }

    if (this.selectedOption.controlType == ControlType.Comparison) {
      this.selectedOption.filterValue = this.validateComparison(this.selectedOption.filterValue);
    }

    let selectedIds = '';
    let userNameValues = '';

    // Handle MultiDropDown separately for Min-Max range
    if (this.selectedOption.controlType === ControlType.MultiDropDown) {
      const fromValue = this.selectedOption.fromFilterValue || '';
      const toValue = this.selectedOption.toFilterValue || '';
      if (isSearchClick) {
        const onlyOneSelected = (fromValue && !toValue) || (!fromValue && toValue);
        if (onlyOneSelected) {
          // Show error and block the emit
          this.toastrService.error('Maturity From and Maturity To both should be selected');
          return;
        }
      }
      // Store both values
      if (fromValue && toValue) {
        this.filter[this.selectedOption.key] = {
          fromMaturity: fromValue,
          toMaturity: toValue,
          display: `Min: ${fromValue || ''} - Max: ${toValue || ''}`
        };
      } else {
        this.filter[this.selectedOption.key] = null;
      }
      this.OnSelect.emit(this.filter);
    }
    else if ((this.selectedOption.controlType === ControlType.DropDown || this.selectedOption.controlType === ControlType.AccountDropDown) && selectedObj) {
      var selectedValues = selectedObj.selectedValues ? selectedObj.selectedValues as any[] : selectedObj as any[];
      selectedValues.forEach(x => { selectedIds = selectedIds + (x[this.selectedOption.controlDataBindValue]).toString().trim() + ', '; });
      this.filter[this.selectedOption.key] = selectedIds.substr(0, selectedIds.length - 2);
      this.OnSelect.emit(this.filter);
    }
    else if ((this.selectedOption.controlType === ControlType.ValuesWithIDDropDown) && selectedObj) {
      var selectedValues = selectedObj.selectedValues ? selectedObj.selectedValues as any[] : selectedObj as any[];
      selectedValues.forEach(x => {
        selectedIds = selectedIds + (x[this.selectedOption.controlDataBindValue]).toString().trim() + '; ';
        userNameValues = userNameValues + (x[this.selectedOption.controlDataBindLabel]).toString().trim() + '; ';
      });
      this.filter[this.selectedOption.key] = selectedIds.substr(0, selectedIds.length - 2);
      this.userNameFilter[this.selectedOption.key] = userNameValues.substr(0, userNameValues.length - 2);
    } else if (this.selectedOption.controlType === ControlType.Comparison) {
      this.filter[this.selectedOption.key] = this.selectedOption.filterOperator + ' ' + this.selectedOption.filterValue;
    } else if (this.selectedOption.controlType === this.controlType.DateRange) {
      this.filter[this.selectedOption.key] = this.selectedOption.fromFilterValue && this.selectedOption.toFilterValue
        ? this.datePipe.transform(this.selectedOption.fromFilterValue, MasterConstants.DATE_MMDDYYYY) + ' ' + this.datePipe.transform(this.selectedOption.toFilterValue, MasterConstants.DATE_MMDDYYYY)
        : null;
    } else if (this.selectedOption.controlType === this.controlType.Date) {
      this.filter[this.selectedOption.key] = this.selectedOption.filterValue ? this.datePipe.transform(this.selectedOption.filterValue, MasterConstants.DATE_MMDDYYYY) : null;
    } else if (this.selectedOption.controlType === this.controlType.CalendarMonthYear) {
      this.filter[this.selectedOption.key] = this.selectedOption.filterValue.format('MM/yyyy');
    }
    else if (this.selectedOption.controlType !== ControlType.DropDown && this.selectedOption.controlType !== ControlType.AccountDropDown && this.selectedOption.controlType !== ControlType.ValuesWithIDDropDown && this.selectedOption.controlType !== ControlType.MultiDropDown) {
      this.filter[this.selectedOption.key] = this.selectedOption.filterValue;
    }

    this.filterValueList = [];
    const filtrKeys = Object.keys(this.filter);
    filtrKeys.forEach(x => {
      if (this.filter[x]) {
        const optionData = this.optionsData.find(y => y.key === x);
        let chipValue;
        if (optionData.controlType === ControlType.MultiDropDown) {
          // For range-based MultiDropDown
          const fromValue = optionData.fromFilterValue || '';
          const toValue = optionData.toFilterValue || '';

          if (fromValue && toValue) {
            chipValue = `${fromValue} - ${toValue}`;
            //} else if (fromValue) {
            //  chipValue = `Min: ${fromValue}`;
            //} else if (toValue) {
            //  chipValue = `Max: ${toValue}`;
            //}
          }
          else {
            chipValue = '';
          }
        }
        else if (optionData.controlType === ControlType.DropDown || optionData.controlType === ControlType.AccountDropDown) {
          const selectedDdlValues = this.filter[x].split(',');
          if (selectedDdlValues && selectedDdlValues.length > 0) {
            let selectedLabels = '';
            selectedDdlValues.forEach(y => {
              selectedLabels = selectedLabels +
                optionData.controlData.find(z => (z[optionData.controlDataBindValue]).toString().trim() == y.toString().trim())[optionData.chipLabel ? optionData.chipLabel : optionData.controlDataBindLabel] +
                ', ';
            });
            chipValue = selectedLabels.substr(0, selectedLabels.length - 2);
          }
        } else if (optionData.controlType === ControlType.Comparison) {
          chipValue = this.filter[x];
        } else if (optionData.controlType === ControlType.DateRange) {
          const dates = this.filter[x].split(' ');
          chipValue = `(${dates[0]}) - (${dates[1]})`;
        }
        else if (optionData.controlType === ControlType.ValuesWithIDDropDown) {
          chipValue = this.userNameFilter[x];
        }
        else if (optionData.controlType === ControlType.MultiDropDown) {
          const filterObj = this.filter[x];
          if (filterObj && typeof filterObj === 'object') {
            chipValue = filterObj.display;
          } else {
            chipValue = this.filter[x];
          }
        }
        else {
          chipValue = this.filter[x];
        }
        this.filterValueList.push(`${optionData.label} : ${chipValue}`);
      }
    });

    if (!isSearchClick && (this.selectedOption.controlType === ControlType.Text || this.selectedOption.controlType === ControlType.Integer)) {
      this.searchClick.emit(this.filter);
    }
  }

  // Validate number text as integer
  validateNumText(numInput) {
    if (numInput == null) { return numInput; }
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }

  // Validate comparison Value
  validateComparison(input) {
    const QtyRegx = RegExp('^[0-9]+$');
    const isValidInput = (input ? QtyRegx.test(input) : true);
    if (!isValidInput) {
      this.toastrService.error('Invalid Input.');
      input = null;
    }
    return input;
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      this.searchClick.emit(this.filter);
    }
  }

  //Select filter
  public selectFilter() {
    const sanitizedFilterOptions = this.optionsData.map(({ controlData, ...rest }) => ({
      ...rest
    }));

    const filters: UserFilterColumnDisplayed = {
      filterOption: sanitizedFilterOptions,
      filterValueList: this.filterValueList,
      filter: this.filter
    };

    this.selectFilterClick.emit(filters);
  }

  //Add filter
  public addFilter() {

    const sanitizedFilterOptions = this.optionsData.map(({ controlData, ...rest }) => ({
      ...rest
    }));

    const filters: UserFilterColumnDisplayed = {
      filterOption: sanitizedFilterOptions,
      filterValueList: this.filterValueList,
      filter: this.filter
    };

    this.addFilterClick.emit(filters);
  }

  //Edit filter
  public editFilter() {
    const sanitizedFilterOptions = this.optionsData.map(({ controlData, ...rest }) => ({
      ...rest
    }));

    const filters: UserFilterColumnDisplayed = {
      filterOption: sanitizedFilterOptions,
      filterValueList: this.filterValueList,
      filter: this.filter
    };
    this.editFilterClick.emit(filters);
  }

  public save() {
    const sanitizedFilterOptions = this.optionsData.map(({ controlData, ...rest }) => ({
      ...rest
    }));

    const filters: UserFilterColumnDisplayed = {
      filterOption: sanitizedFilterOptions,
      filterValueList: this.filterValueList,
      filter: this.filter
    };

    this.saveFilterClick.emit(filters);
  }
  //To remove/clear selected chip search filter 
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const removedItem = this.optionsData.find(y => y.label === removeFilter[0].trim());
    if (removedItem.controlType === ControlType.DropDown) {
      removedItem.filterValue = [];
    } else if (removedItem.controlType === this.controlType.DateRange) {
      removedItem.fromFilterValue = null;
      removedItem.toFilterValue = null;
      removedItem.fromDateValidateFilter = false;
      removedItem.toDateValidateFilter = false;
    }
    else if (removedItem.controlType === ControlType.MultiDropDown)
    {
      removedItem.fromFilterValue = null;
      removedItem.toFilterValue = null;
    }
    else {
      removedItem.filterValue = null;
    }
    this.filter[removedItem.key] = null;
  }

  //�Clear�all�filter
  clearAllFilter() {
    this.clearAllFilterWithoutEmit()
    this.clearAllClick.emit(this.filter);
  }
  onMaturityFromChange() {
    if (this.selectedOption.fromFilterValue && this.selectedOption.toFilterValue) {
      // Validate From <= To
      if (this.compareMaturityValues(this.selectedOption.fromFilterValue, this.selectedOption.toFilterValue) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');

        // clear model value and visually deselect the To dropdown
        this.selectedOption.toFilterValue = null;
        this.clearNgSelectModel(this.maturityToSelect);

        // update internal filter state (MultiDropDown reads selectedOption.fromFilterValue / toFilterValue)
        this.retainFilter(null);
        return;
      }
    }
  }

  // Validate when Maturity To changes
  onMaturityToChange() {
    if (this.selectedOption.fromFilterValue && this.selectedOption.toFilterValue) {
      // Validate From <= To
      if (this.compareMaturityValues(this.selectedOption.fromFilterValue, this.selectedOption.toFilterValue) > 0) {
        this.toastrService.error('Maturity To should be greater than or equal to Maturity From');

        // clear model value and visually deselect the To dropdown
        this.selectedOption.toFilterValue = null;
        this.clearNgSelectModel(this.maturityToSelect);

        // update internal filter state
        this.retainFilter(null);
        return;
      }
    } else if (!this.selectedOption.fromFilterValue && this.selectedOption.toFilterValue) {
      // If only To is selected, show warning and deselect To
      this.toastrService.warning('Maturity From and Maturity To both should be selected');

      this.selectedOption.toFilterValue = null;
      this.clearNgSelectModel(this.maturityToSelect);
      this.retainFilter(null);
      return;
    }
  }
  private clearNgSelectModel(select: NgSelectComponent) {
    if (!select) { return; }
    const anySelect = select as any;
    try {
      if (typeof anySelect.clearModel === 'function') {
        anySelect.clearModel();
      }
      if (typeof anySelect.clear === 'function') {
        anySelect.clear();
      }
      // fallback: clear selectedItems / selectedValue if present
      if ('selectedItems' in anySelect) {
        anySelect.selectedItems = [];
      }
      if ('selectedValue' in anySelect) {
        anySelect.selectedValue = null;
      }
    } catch (e) {
      // noop - best-effort clear
    }
    // ensure Angular picks up the change
    this.cdRef.detectChanges();
  }

  compareMaturityValues(from: string, to: string): number {
    const fromValue = this.extractMaturityNumericValue(from);
    const toValue = this.extractMaturityNumericValue(to);
    return fromValue - toValue;
  }

  // Extract numeric value from maturity string (e.g., "0.9-1.4" -> 0.9)
  extractMaturityNumericValue(maturityString: string): number {
    if (!maturityString) return 0;
    const parts = maturityString.split('-');
    return parts.length > 0 ? parseFloat(parts[0]) : 0;
  }

  //Clear all filter
  clearAllFilterWithoutEmit() {
    this.filterValueList = new Array();
    this.resetPageFilter();
    this.selectedValue = this.optionsData && this.optionsData.length ? this.optionsData[0].key : null;
    this.selectedOption = this.optionsData && this.optionsData.length ? this.optionsData[0] : null;
    this.checkAndSetDefaultOptionValues();
  }

  // Reset all filters
  resetPageFilter() {
    this.filterValueList = [];

    this.optionsData.forEach(x => {
      if (x.controlType === ControlType.DropDown) {
        x.filterValue = [];
      } else if (x.controlType === this.controlType.DateRange) {
        x.fromFilterValue = null;
        x.toFilterValue = null;
        x.fromDateValidateFilter = false;
        x.toDateValidateFilter = false;
      }
      else if (x.controlType === ControlType.MultiDropDown)
      {
        x.fromFilterValue = null;
        x.toFilterValue = null;
      }
      else {
        x.filterValue = null;
      }
      this.filter[x.key] = null;
    });
  }

  // Search the details on dropdown
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    if (item.value != undefined) {
      return item.value.toLocaleLowerCase().indexOf(term) > -1;
    } else if (item.accountNameCityState != undefined) {
      return item.accountNameCityState.toLocaleLowerCase().indexOf(term) > -1;
    }
  }

  // Search the account details on Account dropdown
  ddlAccountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }
  dateRangeFilterValidation(contextFrom, $event) {
    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.selectedOption.toFilterValue) {
        var toDate = new Date(this.selectedOption.toFilterValue);
        this.selectedOption.fromDateValidateFilter = (d: Date): boolean => d <= toDate;
      }
      this.selectedOption.toDateValidateFilter = (d: Date): boolean => d >= fromDate;
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.selectedOption.fromDateValidateFilter = (d: Date): boolean => d <= toDate;
      if (this.selectedOption.fromFilterValue) {
        var fromDate = new Date(this.selectedOption.fromFilterValue);
        this.selectedOption.toDateValidateFilter = (d: Date): boolean => d >= fromDate;
      }
    }
  }

  public releaseOrder() {
    this.releaseOrderClick.emit();
  }
}
